import radium from 'radium';

function LeoForm(props) {
	const style = {
		width: '100%',
	};

	return (
		<form onSubmit={props.onSubmit} style={style} id={props.id}>
			{props.children}
		</form>
	);
}


export default radium(LeoForm);
